module.exports = __webpack_public_path__ + "media/images/lp/lp1-main-sp-7096e2d03988158c9473da2a1f46c642.jpg";